import React from 'react'
import { useTranslation } from 'react-i18next'

import { Dropdown, DropdownProps } from 'primereact/dropdown'
import { Skeleton } from 'primereact/skeleton'

import { TrialTemplate, useAllTrialTemplates } from '../../data'

type TemplateDropDownProps = {
  selectedTemplate?: TrialTemplate
  onSelectedTemplateChanged: (template: TrialTemplate) => void
  isRequestRunning: boolean
}

const TemplateDropdown: React.FC<TemplateDropDownProps> = ({
  selectedTemplate: value,
  onSelectedTemplateChanged,
  isRequestRunning,
}) => {
  const { t } = useTranslation()
  const { data, isLoading } = useAllTrialTemplates()

  if (isLoading) {
    return <Skeleton className="w-full md:max-w-25rem" height="37px"></Skeleton>
  }

  const groupedItemTemplate = (option: any) => {
    switch (option.optionGroup.TemplateType) {
      case 'DELIVERYFORECAST':
        return t('trial.generatebo.optionGroupLabel.deliveryForecasts')
      case 'ORDERRESPONSE':
      default:
        return t('trial.generatebo.optionGroupLabel.orderResponses')
    }
  }

  const itemTemplate = (option: TrialTemplate) => {
    return <>{option?.DisplayName || option?.Name}</>
  }

  const selectedItemTemplate = (
    option: TrialTemplate,
    props: DropdownProps,
  ) => {
    if (option) {
      return <>{option?.DisplayName || option?.Name}</>
    }

    return <>{props.placeholder}</>
  }

  return (
    <Dropdown
      value={value}
      options={data}
      optionLabel="Name"
      placeholder={t('trial.generatebo.labels.templatesplaceholder')}
      onChange={e => onSelectedTemplateChanged(e.value as TrialTemplate)}
      className="w-full md:max-w-25rem"
      optionGroupLabel="TemplateType"
      optionGroupChildren="Templates"
      optionGroupTemplate={groupedItemTemplate}
      valueTemplate={selectedItemTemplate}
      itemTemplate={itemTemplate}
      disabled={isRequestRunning}
    />
  )
}

export default TemplateDropdown
